import { ToastOptions, toast } from 'react-toastify';
import { twMerge } from 'tailwind-merge';

import DefaultCloseButton from './DefaultCloseButton';

const commonClassName =
  '!rounded-lg !m-4 sm:!m-0 !text-white font-semibold items-center gap-4 !pl-4 !pr-2';

const defaultOptions = {
  position: toast?.POSITION?.TOP_RIGHT,
  icon: false,
  closeButton: DefaultCloseButton,
};

const showError = (message: string, options?: ToastOptions) => {
  toast?.error?.(message, {
    className: twMerge(commonClassName, '!bg-danger-700'),
    ...defaultOptions,
    ...options,
  });
};

const showSuccess = (message: string, options?: ToastOptions) => {
  toast?.success?.(message, {
    className: twMerge(commonClassName, '!bg-green-700'),
    ...defaultOptions,
    ...options,
  });
};

const showInfo = (message: string, options?: ToastOptions) => {
  toast?.info?.(message, {
    className: twMerge(commonClassName, '!bg-black'),
    ...defaultOptions,
    ...options,
  });
};

// ts-prune-ignore-next
export { showError, showInfo, showSuccess };
